import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate';
import './registerServiceWorker'
import router from './router'
import store from './store'
import ApiService from "@/common/api.service";
import AuthService from "@/common/auth.service"
import { setTimeout } from "@/utils/authUtils.js"
import moment from 'moment'
Vue.prototype.moment = moment
ApiService.init()
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "@/styling.scss"

import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import ErrorFilter from "./common/error.filter";
Vue.filter("error", ErrorFilter);

router.beforeEach((to, from, next) => {
  const authRequired = to.meta.requiresAuth;
  const allowedUsers = to.meta.allowedUsers;
  const isOrganisationIdPresent = localStorage.getItem('organisationId');
  const isRolePresent = localStorage.getItem('role');


  if ((from.name === null || from.name === 'Login') && to.name != null && to.name != 'Login') {
    setTimeout(Date.now());
  }
  AuthService.Token.then(response => {
    if (response !== null) {
      ApiService.setHeader();
      if (isOrganisationIdPresent) {
        ApiService.setOrganisationId(isOrganisationIdPresent);
      }
    }

    if (response === null && authRequired) {
      router.push("/login");
    }
    else if (response !== null && authRequired) {
      if (isOrganisationIdPresent && isRolePresent) {
        if(allowedUsers) {
          if(allowedUsers.includes(localStorage.getItem('role'))) {
            next();
          }
          else {
            router.push('/home')
          }
        }
        else {
          next();
        }
      }
      else if (!isOrganisationIdPresent && !isRolePresent) {
        if (to.path === '/selectOrganisation') {
          next();
        } else {
          router.push("/selectOrganisation")
        }
      }
    }
    else {
      next()
    }

  })
})

import LoadScript from 'vue-plugin-load-script';

//Sentry Monitor
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing"
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://1ea29c6305b44316bc194b281b7655ef@o460689.ingest.sentry.io/5480280",
    integrations: [
      new Integrations.BrowserTracing(),
      new VueIntegration({
        Vue,
        tracing: true,
      }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}
Vue.use(LoadScript);

Amplify.configure(awsconfig);
applyPolyfills().then(() => {
  defineCustomElements(window);
});
// Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.ignoredElements = [/amplify-\w*/];

Vue.config.silent = false
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(require('vue-cookies'))


// es2015 module

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Vuelidate);

Vue.config.productionTip = true

const app = new Vue({
  router,
  store,
  validations: {},
  render: h => h(App)
}).$mount('#app')

if (window.Cypress) {
  // only available during E2E tests
  window.app = app
}
